import { render, staticRenderFns } from "./EcpDeptSelect.vue?vue&type=template&id=1af5a19a&scoped=true"
import script from "./EcpDeptSelect.vue?vue&type=script&lang=js"
export * from "./EcpDeptSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af5a19a",
  null
  
)

export default component.exports